<template>
        <div>
            <h3 class="editor-header" v-if="!this.isAddEquipmentMode">
                {{ $t('drain.drain')  }}
            </h3>
            <location-deviation v-if="!this.isAddEquipmentMode" :location-deviation="item.location_deviation"/>
            <div class="px-2">
                <div class="row" v-if="!this.isAddEquipmentMode">
                    <div class="col-sm-6">
                        <span class="span-title">{{ $t('common.id') }}</span>
                        <span class="item-detail-text">{{ item.external_system_id }}</span>
                    </div>
                    <div class="col-sm-6">
                        <road-addess-view :road-number="item.road_num" :section-number="item.road_sec" :distance="item.distance" :show-street-name="false"/>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('drain.type') }}</span>
                        <select
                            v-model="item.type"
                            class="form-select form-select-sm"
                            :class="{ 'is-valid': validateIsNumber(item.type), 'is-invalid': !validateIsNumber(item.type) }"
                        >
                            <option
                                v-for="option in getDrainTypes()"
                                :key="option.value"
                                :value="option.value"
                            >
                                {{ option.name }}
                            </option>
                        </select>
                    </div>
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('drain.material') }}</span>
                        <select
                            v-model="item.material"
                            class="form-select form-select-sm"
                            :class="{ 'is-valid': validateIsNumber(item.material), 'is-invalid': !validateIsNumber(item.material) }"
                        >
                            <option
                                v-for="option in getDrainMaterials()"
                                :key="option.value"
                                :value="option.value"
                            >
                                {{ option.name }}
                            </option>
                        </select>
                    </div>
                    <div class="col-sm-4">
                        <condition-selector v-model="item.condition"/>
                    </div>
                </div>
                <div class="row">
                    <location-details
                        v-if="!this.isAddEquipmentMode"
                        :lane-data="item.location_specification.lane"
                        :side-data="item.location_specification.side"
                        :track-data="item.location_specification.tracks"
                    />
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('drain.cover_type.title') }}</span>
                        <select
                            v-model="item.cover_type"
                            class="form-select form-select-sm"
                            :class="{
                                'is-valid': isStormDrain(item.type) && validateIsNumber(item.cover_type),
                                'is-invalid': isStormDrain(item.type) && !validateIsNumber(item.cover_type)
                              }"
                        >
                            <option
                                v-for="option in getDrainCoverTypes()"
                                :key="option.value"
                                :value="option.value"
                            >
                                {{ option.name }}
                            </option>
                        </select>
                    </div>
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('drain.cover_material') }}</span>
                        <select
                            v-model="item.cover_material"
                            class="form-select form-select-sm"
                            :class="{
                                'is-valid': validateIsNumber(item.cover_material),
                                'is-invalid': !validateIsNumber(item.cover_material)
                              }"
                            >
                            <option
                                v-for="option in getDrainCoverMaterials()"
                                :key="option.value"
                                :value="option.value"
                            >
                                {{ option.name }}
                            </option>
                        </select>
                    </div>
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('drain.cover_size') }}</span>
                        <input
                            id="cover_size"
                            v-model="item.cover_size"
                            type="number"
                            class="form-control form-control-sm"
                            :class="{
                                'is-valid': isStormDrain(item.type) && validateIsNumber(item.cover_size),
                                'is-invalid': isStormDrain(item.type) && !validateIsNumber(item.cover_size)
                              }"
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('drain.cover_load_class') }}</span>
                        <input
                            id="cover_load_class"
                            v-model="item.cover_load_class"
                            type="number"
                            class="form-control form-control-sm"
                        />
                    </div>

                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('drain.cover_adjustment_mechanism.title') }}</span>
                        <select
                            v-model="item.cover_adjustment_mechanism"
                            class="form-select form-select-sm"
                        >
                            <option
                                v-for="item in getDrainCoverAdjustmentMechanisms()"
                                :key="item.value"
                                :value="item.value"
                            >
                                {{ item.name }}
                            </option>
                        </select>
                    </div>

                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('drain.cover_height_position') }}</span>
                        <input
                            id="cover_height_position"
                            v-model="item.cover_height_position"
                            type="number"
                            class="form-control form-control-sm"
                            :class="{
                                'is-valid': validateIsNumber(item.cover_height_position),
                                'is-invalid': !validateIsNumber(item.cover_height_position)
                            }"
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('drain.depth') }}</span>
                        <input
                            id="depth"
                            v-model="item.depth"
                            type="number"
                            class="form-control form-control-sm"
                            :class="{
            'is-valid': validateIsNumber(item.depth),
            'is-invalid': !validateIsNumber(item.depth)
        }"
                        />
                    </div>

                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('drain.cover_adjustment_option') }}</span>
                        <div class="form-check form-check-inline">
                            <input
                                id="cover_adjustment_option"
                                v-model="item.cover_adjustment_option"
                                type="checkbox"
                                class="form-check-input"
                                :true-value="'true'"
                                :false-value="'false'"
                            />
                            <label for="cover_adjustment_option" class="form-check-label">{{ $t('drain.cover_adjustment_option') }}</label>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('drain.precipitation_nest') }}</span>
                        <div class="form-check form-check-inline">
                            <input
                                id="precipitation_nest"
                                v-model="item.precipitation_nest"
                                type="checkbox"
                                class="form-check-input"
                                :true-value="'true'"
                                :false-value="'false'"
                            />
                            <label for="precipitation_nest" class="form-check-label">{{ $t('drain.precipitation_nest') }}</label>
                        </div>
                    </div>
,                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('drain.precipitation_nest_depth') }}</span>
                        <input
                            id="depth"
                            v-model="item.precipitation_nest_depth"
                            type="number"
                            class="form-control form-control-sm"
                        />
                    </div>

                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('drain.drain_outlets') }}</span>
                        <input
                            id="drain_outlets"
                            v-model="item.drain_outlets"
                            type="number"
                            class="form-control form-control-sm"
                            :class="{
                                'is-valid': isStormDrain(item.type) && validateIsNumber(item.drain_outlets),
                                'is-invalid': isStormDrain(item.type) && !validateIsNumber(item.drain_outlets)
                            }"
                        />
                    </div>

                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('drain.drain_inputs') }}</span>
                        <input
                            id="drain_inputs"
                            v-model="item.drain_inputs"
                            type="number"
                            class="form-control form-control-sm"
                            :class="{
                                'is-valid': isStormDrain(item.type) && validateIsNumber(item.drain_inputs),
                                'is-invalid': isStormDrain(item.type) && !validateIsNumber(item.drain_inputs)
                            }"
                        />
                    </div>
                <div class="row">
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('drain.inside_diameter') }}</span>
                        <input
                            id="inside_diameter"
                            v-model="item.inside_diameter"
                            type="number"
                            class="form-control form-control-sm"
                            :class="{
                                'is-valid': validateIsNumber(item.inside_diameter),
                                'is-invalid': !validateIsNumber(item.inside_diameter)
                            }"
                        />
                    </div>

                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('drain.base_elevation') }}</span>
                        <input
                            id="base_elevation"
                            v-model="item.base_elevation"
                            type="number"
                            class="form-control form-control-sm"
                            :class="{
                                'is-valid': validateIsNumber(item.base_elevation),
                                'is-invalid': !validateIsNumber(item.base_elevation)
                            }"
                        />
                    </div>

                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('drain.wall_thickness') }}</span>
                        <input
                            id="wall_thickness"
                            v-model="item.wall_thickness"
                            type="number"
                            class="form-control form-control-sm"
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('drain.product_name') }}</span>
                        <input
                            id="product_name"
                            v-model="item.product_name"
                            type="text"
                            class="form-control form-control-sm"
                            minlength="1"
                        />
                    </div>

                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('portal.code') }}</span>
                        <input
                            id="height"
                            v-model="item.code"
                            type="text"
                            class="form-control form-control-sm"
                            minlength="1"
                        />
                    </div>
                    <div class="col-sm-4" v-if="this.isAddEquipmentMode">
                        <location-deviation :editMode="true" :location-deviation="item.location_deviation" @updateLocationDeviation="updateLocationDeviation"/>
                    </div>
                </div>
                <div class="row" v-if="this.isAddEquipmentMode">
                    <div class="col-sm-12 nopads mt-2">
                        <h4 class="form-header nopads mt-0">{{ $t('velho_equipment.location_spesifications') }}</h4>
                        <velho-equipment-location-details-editor
                            :hideRampSelector="true"
                            :hideShoulderSelector="true"
                            :hidePlatformSelector="true"
                            :hideEdgeAreaSelector="true"
                            :hideDitchBottomSelector="true"
                            :hideDividerSelector="true"
                            :hideCenterAreaSelector="true"
                            :roadInfo="item"
                            :locationSpecification="item.location_specification"
                            :sideRequired="item.location_deviation !== null && this.sideRequired(item.location_deviation)"
                            :hideSideSelector="!this.sideRequired(item.location_deviation)"
                            :hideTracksSelector="true"
                            :tracksRequired="false"
                        />
                    </div>
                </div>
                <hr class="mb-0">
                <div class="row" v-if="this.isAddEquipmentMode">
                    <div class="col-sm-6 nopads mt-2">
                        <equipment-date
                            :text="$t('velho_equipment.start_date')"
                            v-model="item.created_at"
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 nopads mt-2">
                        <velho-equipment-damages :items="item.equipment_damages"/>
                    </div>
                </div>
                 <div class="row">
                        <equipment-actions v-if="!this.isAddEquipmentMode" ref="actions" v-model="item.actions" />
                </div>
                <div class="row">
                    <linked-equipment
                        v-if="item.linked_equipment && item.linked_equipment.length > 0"
                        :linked-equipments="item.linked_equipment"
                    />
                </div>
            </div>
            </div>
            <velho-editor-buttons
                v-if="!this.isAddEquipmentMode"
                :url="extDrainsUrl"
                :selected-contract="selectedContract"
                :item="item"
                :disabled="loading"
                @close="close"
                @submit="handleSubmit"
                @removalConfirmed="removalConfirmed"
            />
        <div
            v-if="loading > 0"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>
import {mapHelper} from "@/components/mixins/MapMixin";
import {conversionModelHelper} from "@/components/mixins/ConversionMixin";
import {restApi} from "@/components/mixins/RestApiMixin";
import ConditionSelector from "@/components/velho/ConditionSelector";
import {deviations, velhoHelper} from "@/components/mixins/VelhoMixin";
import EquipmentActions from "@/components/velho/EquipmentActions";
import {drainHelper} from "@/components/mixins/DrainMixin";
import VelhoEditorButtons from "@/components/velho/VelhoEditorButtons";
import LinkedEquipment from "@/components/velho/LinkedEquipment";
import LocationDetails from "@/components/velho/LocationDetails.vue";
import LocationDeviation from "@/components/velho/LocationDeviation";
import VelhoEquipmentLocationDetailsEditor from "@/components/velho/VelhoEquipmentLocationDetailsEditor";
import VelhoEquipmentDamages from "@/components/velho/VelhoEquipmentDamages";
import RoadAddessView from "@/components/velho/RoadAddressView";
import {velhoValidationMixin} from "@/components/mixins/VelhoValidationMixin";
import {velhoRequiredMixin} from "@/components/mixins/VelhoRequiredMixin";
import EquipmentDate from "@/components/velho/EquipmentDate.vue";

export default {
    name: 'DrainEditor',
    components: {
        EquipmentDate,
        RoadAddessView,
        LocationDeviation, VelhoEquipmentLocationDetailsEditor, VelhoEquipmentDamages,
        LocationDetails, VelhoEditorButtons, EquipmentActions, ConditionSelector, LinkedEquipment},
    mixins: [mapHelper, conversionModelHelper, restApi, velhoHelper, drainHelper, velhoValidationMixin, velhoRequiredMixin],
    props: {
        item: {
            type: Object,
            default: null
        },
        selectedContract: {
            type: Object,
            default: null
        },
        addEquipmentEditor: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isAddEquipmentMode() {
            return this.addEquipmentMode
        }
    },
    data() {
        return {
            addEquipmentMode: this.addEquipmentEditor,
            map: null,
            loading: false,
        }
    },
    methods: {
        handleSubmit: function(url, item, selectedContract, replace = false) {
            if(replace) {
                this.submitEquipmentsreplace(this.extEquipmentsReplaceUrl, [item], selectedContract)
            } else {
                this.submitEquipment(url, item, selectedContract);
            }
        },
        close: function () {
            this.$emit('close')
        },
        updateLocationDeviation(value) {
            this.item.location_deviation = value
            if(value === deviations.AT_THE_END_OF_THE_ROAD) {
                item.location_specification.side = null
            }
        },
        isValidForm: function() {
            if(!this.item) { return false }
            if(!this.validateIsNumber(this.item.type)) { return false }
            if(!this.validateRoadNumber(this.item.road_num)) { return false }
            if(!this.validateRoadSection(this.item.road_sec)) { return false }
            if(!this.validateRoadDistance(this.item.distance)) { return false }
            if(!this.validateIsNumber(this.item.type)) { return false }
            if(!this.validateIsNumber(this.item.material)) { return false }
            if(!this.validateIsNumber(this.item.inside_diameter)) { return false }
            if(!this.validateIsNumber(this.item.depth)) { return false }
            if(!this.validateIsNumber(this.item.cover_height_position)) { return false }
            if(!this.validateIsNumber(this.item.base_elevation)) { return false }

            if(this.isStormDrain(this.item.type)) {
                this.validateIsNumber(this.item.drain_outlets)
                this.validateIsNumber(this.item.drain_inputs)
                this.validateIsNumber(this.item.cover_size)
                this.validateIsNumber(this.item.cover_type)
            }

            if(this.item.location_deviation !== null && this.sideRequired(this.item.location_deviation)) {
                if(!this.validateRoadSide(this.item.location_specification.side)) { return false }
            }

            return true;
        }
    }
}
</script>

<style scoped>
</style>

